import useSWR from 'swr'
import queryString from 'query-string'
import { formatDate } from '../../../../utils/formatters'
import { ERROR_RETRY_SWR } from '../../../../utils/constants'

export const useDashboardReports = (professionalId, selectedDate, revalidateOnFocus = false) => {
  const query = {
    start: formatDate({ date: selectedDate.clone().startOf('month'), format: 'DD-MM-YYYY' }),
    end: formatDate({ date: selectedDate, format: 'DD-MM-YYYY' })
  }

  const url = `${process.env.REACT_APP_SCHEDULER_URL}/report/professional/${professionalId}/dashboard?${queryString.stringify(query,
    { arrayFormat: 'bracket' })}`

  const { data, error } = useSWR(url, { revalidateOnFocus, errorRetryCount: ERROR_RETRY_SWR })

  if (error) {
    console.error(error)
    return
  }

  return data
}
